import { Col, Row } from "../components/Grid/";
import Hero, { HeroText } from "../components/Hero";
import ProductBar, { Tab } from "../components/ProductBar";

import ContentBlock from "../components/ContentBlock";
import DividerImage from "../components/DividerImage";
import HtmlContainer from "../components/HtmlContainer";
import Image from "../components/Image";
import OrderButton from "../components/OrderButton";
import PricingContainer from "../components/PricingContainer";
import PropTypes from "prop-types";
import React from "react";
import SvgImage from "../components/SvgImage";
import TextSection from "../components/TextSection";
import Video from "../components/Video";
import injectSheet from "react-jss";
import HeroImg from "../img/Hero-gov.jpg";
import ThirdSectionImage from "../img/FOI-gov.png";
import FirstBackground from "../img/Background-gov-1.jpg";
import SecondBackground from "../img/Background-gov-2.jpg";
import ThirdBackground from "../img/Background-gov-3.jpg";
import FourthBackground from "../img/Background-gov-4.jpg";

const styles = theme => ({
  navcolour: {
    backgroundColor: theme.colours.products.gov
  },
  bulletLists: {
    textAlign: "left",
    maxWidth: "30vw",
    "@media (max-width: 823px)": {
      maxWidth: "80vw"
    },
    "& h2": {
      fontSize: "2.2rem",
      fontWeight: 100,
      margin: "1rem",
      textAlign: "center"
    }
  },
  bulletSection: {
    width: "100%",
    "@media (max-width: 823px)": {
      display: "none"
    }
  },
  bulletSectionMobile: {
    "@media (min-width: 824px)": {
      display: "none"
    }
  },
  text: {
    width: "50vw",
    paddingLeft: "2.5rem",
    "@media (max-width: 823px)": {
      padding: 0,
      width: "90%"
    },
    "& h1": {
      fontSize: "5.4rem",
      margin: "1rem",
      textAlign: "center",
      "@media (max-width: 823px)": {
        fontSize: "2.2rem"
      }
    }
  },
  video: {
    width: "50vw",
    height: "40vh",
    "@media (max-width: 414px)": {
      marginTop: "0.5rem",
      width: "90vw",
      height: "28vh"
    },
    "@media (min-width: 415px) and (max-width: 823px)": {
      height: "90vh",
      width: "74vw"
    },
    "@media (min-width: 767px) and (max-width: 769px)": {
      height: "30vh"
    },
    "@media (min-width: 1023px) and (max-width: 1025px) and (min-height: 1365px)": {
      height: "30vh",
      width: "70vw"
    }
  },
  image: {
    width: "500px",
    "@media (max-width: 823px)": {
      display: "none"
    }
  },
  mobileImage: {
    width: "325px",
    "@media (min-width: 824px)": {
      display: "none"
    }
  },
  contentBox: {
    minHeight: "100vh"
  },
  pricingContainer: {
    width: "100%"
  },
  pricing: {
    width: "35vw",
    "@media (max-width: 823px)": {
      padding: 0,
      width: "90%"
    },
    "& h1": {
      fontSize: "5.4rem",
      fontWeight: 400,
      margin: "1rem",
      textAlign: "center",
      "@media (max-width: 823px)": {
        fontSize: "3rem"
      }
    }
  },
  pricingParagraph: {
    maxWidth: "568px"
  }
});

const NavTabs = [
  {
    tabLink: "#video",
    tabName: "Video"
  },
  {
    tabLink: "#features",
    tabName: "Features"
  },
  {
    tabLink: "#pricing",
    tabName: "Pricing"
  },
  {
    tabLink: "/contact",
    tabName: "Support"
  }
];

const GovPage = ({ classes, data }) => (
  <div>
    <ProductBar
      className={classes.navcolour}
      logoLink="/gov"
      logoSrc="/gov-logo.svg"
    >
      {NavTabs.map(tab => (
        <Tab key={tab.tabName} tabLink={tab.tabLink} tabName={tab.tabName} />
      ))}
    </ProductBar>
    <Hero hero={HeroImg} withBar>
      <Row top center>
        <HeroText>
          <HtmlContainer content={data.HeroText.html} />
        </HeroText>
      </Row>
    </Hero>
    <div id="video" />
    <ContentBlock className={classes.contentBox}>
      <Col middle center>
        <TextSection className={classes.text}>
          <HtmlContainer content={data.FirstContentSection.html} />
        </TextSection>
        <br />
        <Video
          src="//www.youtube.com/embed/0y_gRbWLuSM?rel=0&amp;showinfo=0"
          className={classes.video}
          name="Gov Video"
        />
      </Col>
    </ContentBlock>
    <DividerImage image={FirstBackground} />
    <ContentBlock className={classes.contentBox} id="features">
      <div className={classes.bulletSection}>
        <Row around>
          <Col middle center>
            <SvgImage src="/record-icon.svg" />
            <TextSection className={classes.bulletLists}>
              <HtmlContainer content={data.SecondContentTopLeft.html} />
            </TextSection>
          </Col>
          <Col middle center>
            <SvgImage src="/action-icon.svg" />
            <TextSection className={classes.bulletLists}>
              <HtmlContainer content={data.SecondContentTopRight.html} />
            </TextSection>
          </Col>
        </Row>
        <Row around>
          <Col middle center>
            <SvgImage src="/track-icon.svg" />
            <TextSection className={classes.bulletLists}>
              <HtmlContainer content={data.SecondContentBottomLeft.html} />
            </TextSection>
          </Col>
          <Col middle center>
            <SvgImage src="/analyse-icon.svg" />
            <TextSection className={classes.bulletLists}>
              <HtmlContainer content={data.SecondContentBottomRight.html} />
            </TextSection>
          </Col>
        </Row>
      </div>
      <div className={classes.bulletSectionMobile}>
        <Col middle center>
          <SvgImage src="/record-icon.svg" />
          <TextSection className={classes.bulletLists}>
            <HtmlContainer content={data.SecondContentTopLeft.html} />
          </TextSection>
          <SvgImage src="/action-icon.svg" />
          <TextSection className={classes.bulletLists}>
            <HtmlContainer content={data.SecondContentTopRight.html} />
          </TextSection>
          <SvgImage src="/track-icon.svg" />
          <TextSection className={classes.bulletLists}>
            <HtmlContainer content={data.SecondContentBottomLeft.html} />
          </TextSection>
          <SvgImage src="/analyse-icon.svg" />
          <TextSection className={classes.bulletLists}>
            <HtmlContainer content={data.SecondContentBottomRight.html} />
          </TextSection>
        </Col>
      </div>
    </ContentBlock>
    <DividerImage image={SecondBackground} />
    <ContentBlock className={classes.contentBox}>
      <Col middle center>
        <TextSection className={classes.text}>
          <HtmlContainer content={data.ThirdContentSection.html} />
        </TextSection>
        <Image image={ThirdSectionImage} className={classes.image} />
        <Image image={ThirdSectionImage} className={classes.mobileImage} />
      </Col>
    </ContentBlock>
    <DividerImage image={ThirdBackground} />
    <ContentBlock className={classes.contentBox}>
      <div className={classes.bulletSection}>
        <Row around>
          <Col middle center>
            <SvgImage src="/cloud-icon.svg" />
            <TextSection className={classes.bulletLists}>
              <HtmlContainer content={data.FourthContentFirstColumn.html} />
            </TextSection>
          </Col>
          <Col middle center>
            <SvgImage src="/padlock-icon.svg" />
            <TextSection className={classes.bulletLists}>
              <HtmlContainer content={data.FourthContentSecondColumn.html} />
            </TextSection>
          </Col>
          <Col middle center>
            <SvgImage src="/compatibility-icon.svg" />
            <TextSection className={classes.bulletLists}>
              <HtmlContainer content={data.FourthContentThirdColumn.html} />
            </TextSection>
          </Col>
        </Row>
      </div>
      <div className={classes.bulletSectionMobile}>
        <Col middle center>
          <SvgImage src="/cloud-icon.svg" />
          <TextSection className={classes.bulletLists}>
            <HtmlContainer content={data.FourthContentFirstColumn.html} />
          </TextSection>
          <SvgImage src="/padlock-icon.svg" />
          <TextSection className={classes.bulletLists}>
            <HtmlContainer content={data.FourthContentSecondColumn.html} />
          </TextSection>
          <SvgImage src="/compatibility-icon.svg" />
          <TextSection className={classes.bulletLists}>
            <HtmlContainer content={data.FourthContentThirdColumn.html} />
          </TextSection>
        </Col>
      </div>
    </ContentBlock>
    <DividerImage image={FourthBackground} />
    <ContentBlock className={classes.contentBox} id="pricing">
      <div className={classes.pricing}>
        <Col middle center>
          <TextSection
            className={`${classes.text} ${classes.pricingParagraph}`}
          >
            <HtmlContainer content={data.PricingSection.html} />
          </TextSection>
        </Col>
        <PricingContainer>
          <HtmlContainer
            className={classes.text}
            content={data.PricingChecklist.html}
          />
        </PricingContainer>
        <Col middle center>
          <TextSection
            className={`${classes.text} ${classes.pricingParagraph}`}
          >
            <HtmlContainer content={data.PricingSecondSection.html} />
          </TextSection>
        </Col>
        <Col middle center>
          <OrderButton
            eventlabel="Clicked Gov buy button"
            mailinfo="mailto:sales@electedtechnologies.com?subject=Caseworker.gov Sales Enquiry"
            label="Contact Us"
            phonenumber="0333 344 1225"
          />
        </Col>
      </div>
    </ContentBlock>
  </div>
);

GovPage.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.object
};

export default injectSheet(styles)(GovPage);

/* global graphql */
export const GovQuery = graphql`
  query GovQuery {
    HeroText: markdownRemark(frontmatter: { name: { eq: "Gov-HeroText" } }) {
      html
      frontmatter {
        name
      }
    }
    FirstContentSection: markdownRemark(
      frontmatter: { name: { eq: "Gov-FirstSection" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    SecondContentTopLeft: markdownRemark(
      frontmatter: { name: { eq: "Gov-RecordList" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    SecondContentTopRight: markdownRemark(
      frontmatter: { name: { eq: "Gov-ActionList" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    SecondContentBottomLeft: markdownRemark(
      frontmatter: { name: { eq: "Gov-TrackList" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    SecondContentBottomRight: markdownRemark(
      frontmatter: { name: { eq: "Gov-AnalyseList" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    ThirdContentSection: markdownRemark(
      frontmatter: { name: { eq: "Gov-ThirdSection" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    FourthContentFirstColumn: markdownRemark(
      frontmatter: { name: { eq: "Gov-CloudList" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    FourthContentSecondColumn: markdownRemark(
      frontmatter: { name: { eq: "Gov-SecureList" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    FourthContentThirdColumn: markdownRemark(
      frontmatter: { name: { eq: "Gov-CompatibleList" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    PricingSection: markdownRemark(
      frontmatter: { name: { eq: "Gov-PricingParagraph" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    PricingSecondSection: markdownRemark(
      frontmatter: { name: { eq: "Gov-PricingSecondParagraph" } }
    ) {
      html
      frontmatter {
        name
      }
    }
    PricingChecklist: markdownRemark(
      frontmatter: { name: { eq: "Gov-PricingColumn" } }
    ) {
      html
      frontmatter {
        name
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/gov.jsx